export const incomeTransactionMatchesInvoiceFilter = (
  transaction,
  filter = "all",
) => {
  if (filter !== "unmatched") {
    return true;
  }

  return (
    (!Array.isArray(transaction?.invoices) ||
      transaction.invoices.length === 0 ||
      transaction.unallocated_amount > 0) &&
    !transaction?.review
  );
};
